import React from "react";

const portfolioItems = [
  {
    title: "Tournado – Gaming & Tournament Management",
    image: "/tournado.png",
    description:
      "Esports need structure. Tournado was designed to bring that structure into tournaments. It handles registrations, scheduling, match management, and results, all in one system. For players, referees, and organizers, it creates a fair and professional environment where the focus can stay on the game itself.",
  },
  {
    title: "Blippi – Social Media & Creator Economy",
    image: "/blippi.png",
    description: "Content creators often juggle multiple platforms, which eats into their time and energy. Blippi was created to bring everything under one roof. It helps manage posts, track engagement, and grow communities without the constant switching between apps. For brands and creators alike, it has become a tool for focus and expansion.",
  },
  {
    title: "Furry Met",
    image: "/urrymet.png",
    description: " FurryMet is an innovative pet meeting application designed to connect pet owners and their furry companions. The app makes it easy to arrange playdates, social meetups, and community events, ensuring pets stay active, happy, and socialized. With FurryMet, pet parents can find like-minded companions for their pets while also building lasting friendships within the community. ",
  },
  {
    title: " Maxzeego – Last-Mile Logistics ",
    image: "/maxzeego.png",
    description: "Operating in Australia, Maxzeego focuses squarely on last-mile delivery, one of the trickiest parts of logistics. The platform ties together vendors, drivers, and customers so that everyone is working in sync. Deliveries can be tracked in real time, orders are managed smoothly, and businesses get a tool that boosts efficiency without complicating operations.",
  },
  {
    title: "CKAFO – Food & Restaurant Management",
    image: "/ckafo.png",
    description:
      "Restaurants run on tight schedules. CKAFO was made to cut the chaos out of managing orders. It combines a customer app, a vendor app, a website, and an admin panel into one setup. The result is smoother order handling, real-time updates, and better customer connections. For restaurant owners, it means fewer worries about day-to-day tasks and more freedom to focus on growth.",
  },
  {
    title: "DayaMotos – Automobile Marketplace",
    image: "/dayamotos.png",
    description:
      "DayaMotos is built for people who want more clarity when buying or selling vehicles. It serves as a marketplace for cars and bikes, offering detailed comparisons, reviews, and updated information. Buyers gain confidence in their decisions, while sellers get a trusted place to showcase their listings. It’s straightforward, reliable, and community-driven.",
  },
  {
    title: "GoEV – Green Mobility & Logistics",
    image: "/goev-mob.png",
    description:
      "GoEV represents our step toward sustainability. It runs deliveries on electric vehicles, helping businesses cut down emissions while staying efficient. With smart route planning and fleet management, GoEV blends eco-friendly practices with practical logistics, proving that going green doesn’t have to mean slowing down.",
  },
  {
    title: "Klim Zeal",
    image: "/klim-zeal.png",
    description:
      "Klim Zeal brings together passion, safety, nature, and adventure. More than just a trek operator, they focus on extreme sports, responsible tourism, and mountaineering. Their offerings include guided treks, organized expeditions, custom tour planning, high safety and equipment standards, and an ethos of sustainability. Whether it’s exploring hiking trails, summiting peaks, or doing immersive tours, Klim Zeal makes sure the journey is as fulfilling as the destination, with strong local connection, environmental care, and an unforgettable adventure.",
  },
  {
    title: "WMS – Warehouse Management System",
    image: "/wms.png",
    description:
      "Every warehouse is a mix of movement and storage, and without the right tools it’s easy to lose control. WMS was built to simplify this. It helps businesses track inventory, process orders, and coordinate deliveries with less friction. By improving visibility and cutting errors, WMS gives warehouses the efficiency they need to keep supply chains running smoothly.",
  },
  {
    title: "Indilink – Warehouse & Delivery Management",
    image: "/indi-link.png",
    description:
      "Warehouses can make or break delivery timelines. Indilink helps businesses stay on top of inventory and distribution. It gives real-time insights, simplifies scheduling, and provides performance dashboards that managers can act on. The idea isn’t only to move goods faster, but to give companies the kind of control that keeps customers satisfied.",
  },
  {
    title: "Indimove – Fleet & Logistics Management",
    image: "/indi-move.png",
    description:
      "Deliveries are never just about the last mile. Indimove was designed with that in mind. Customers place orders, drivers handle fulfillment, and behind the scenes the platform ties it all together with warehouse management features. By connecting these dots, Indimove reduces waste, cuts costs, and keeps logistics transparent from start to finish.",
  },
   {
    title: "YPSS (Youngsters’ Platform for Social Service)",
    image: "/ypss.png",
    description:
      "Young people are the driving force of any nation—their energy can uplift societies or, if left misguided, can become destructive. YPSS is a youth-focused organization that seeks to channelize the potential of young people toward higher purposes such as peace, stability, and social change. This dedicated app will act as a private, common space for YPSS volunteers, helping them stay connected, collaborate on initiatives, and remain inspired in their mission to build a world free from violence, corruption, and climate crisis",
  },
  {
    title: "MaxxPak",
    image: "/maxx-pack.png",
    description:
      "MaxxPak is a packaging-solutions store built for reliability, speed, and quality. Their product range covers everything from stretch films, shrink films, steel strapping, poly/pet strapping, pallet wrap, and general industrial packaging. What stands out is that they combine a wide variety of packaging materials with an easy shopping experience, consistent product availability, and competitive pricing. For businesses that need to protect, wrap, ship or secure items, MaxxPak delivers both the materials and the service: fast, dependable, and local.",
  },
  {
    title: "Goody – Logistics & Delivery",
    image: "/goody-1.png",
    description:
      "Moving goods from one place to another sounds simple until you’re the one managing fleets and drivers. Goody takes away that headache. It comes with apps for both customers and drivers, plus admin tools that keep everything under control. Real-time tracking and route optimization make the system dependable. Businesses and individuals alike have used it to turn messy delivery operations into predictable, well-organized workflows.",
  },
   {
    title: "Synapto",
    image: "/synapto.png",
    description:
      "Synapto is a next-generation digital health platform designed to make mental wellness services more accessible, secure, and seamless. It bridges the gap between patients and licensed professionals, offering therapies like meditation, individual counseling, and couple therapy through both web and mobile applications.",
  },
   {
    title: "AutoGTG",
    image: "/auto-gtg.png",
    description: "AutoGTG is an all-in-one platform that makes car care simple and reliable. It offers services like car wash, denting, painting, detailing, repairs, and full servicing — all in one place. Users can find trusted workshops, compare options, and book appointments easily. With verified centers, upfront pricing, and expert technicians, AutoGTG ensures quality, transparency, and convenience for every vehicle owner.",
  },
  {
    title: "Odd Mood",
    image: "/odd-mood.png",
    description:
      "Odd Mood is a contemporary streetwear brand built around mood-driven aesthetics. The project centered on designing an engaging e-commerce experience that captures the brand’s identity, showcases collections with bold visuals, and delivers a seamless shopping journey across devices.",
  },
];

const PortfolioGrid = () => {
  return (
    <section className="py-6 px-4 max-w-6xl mx-auto">
      <h2 className="text-4xl font-bold text-center mb-16 text-[#3087b7]">
        Our Portfolio
      </h2>

      <div className="flex flex-col gap-20">
        {portfolioItems.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col md:flex-row  gap-10 ${
              index % 2 === 1 ? "md:flex-row-reverse" : ""
            }`}
          >
            {/* Image Section */}
            <div className="md:w-1/2 w-full">
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-auto rounded-2xl object-cover"
              />
            </div>

            {/* Content Section */}
            <div className="md:w-1/2 w-full text-center mt-16 md:text-left">
              <h3 className="text-2xl md:text-3xl font-bold text-[#0A033C] mb-3">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-lg">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioGrid;
